import { useEffect, useRef, useState } from "react"
import { useSignal } from "@preact/signals-react"

import Button from "react-bootstrap/esm/Button.js"
import Dropdown from 'react-bootstrap/Dropdown'
import Form from 'react-bootstrap/Form'

import AboutModal from "./AboutModal"
import Icon from "./Icon"

import { submitFormData } from "../utils/api.js"
import { convertUrlReactToEmber, logout } from "../utils/utils.js"
import { useNavigate } from "react-router-dom"

import { removeSelectedBusinessEntityId } from "../state/actions/userSettingsActions.js"

const UserBox = function ({ config, userManifestSignal }){

	const navigate = useNavigate()
	const showUserBoxSignal = useSignal(false)

	const showModalAboutSignal = useSignal(false)
	const handleCloseModalAbout = function () {
		showModalAboutSignal.value = false
	}

	const menuRef = useRef(null)
	const openMenuState = useState(false)

	const emberUrlSignal = useSignal(`${config.emberUrl}/#/dashboard`)

	const closeMenu = function (event){
		if (openMenuState && !menuRef.current?.contains(event.target)) {
			//setOpenMenuState(false)
			showUserBoxSignal.value = false
		}
	}
	document.addEventListener('mousedown', closeMenu)

	const hasProfileImageSignal = useSignal(userManifestSignal.value && userManifestSignal.value.imageSelected)
	useEffect(
		() => {
			hasProfileImageSignal.value = userManifestSignal.value && userManifestSignal.value.imageSelected
		}
	)

	const profileImageSrcSignal = useSignal(null)
	useEffect(
		() => {
			if (hasProfileImageSignal.value && config && config.ssoBaseUrl) {
				profileImageSrcSignal.value = config.ssoBaseUrl.concat("/images/security/").concat(userManifestSignal.value.image).concat(".png")
			}
		}
	)

	const navigateTo4tressUrlSignal = useSignal(null)
	useEffect(
		() => {
			let print = false
			if (print) {
				if (config) {
					if (config.fortressBaseUrl) {
						console.log("4tress base URL is ".concat(config.fortressBaseUrl))
					} else {
						console.log("4tress base URL is undefined")
						console.log(config)
					}
				} else {
					console.log("Config is not defined")
				}
			}
			if (config && config.fortressBaseUrl) {
				navigateTo4tressUrlSignal.value = config.fortressBaseUrl.concat("/#/profile")
			}
		}
	)
	

	return (
		<>
			{
				userManifestSignal.value != null && (
					<Dropdown id="userbox" ref={menuRef}>
						<Dropdown.Toggle style={{ height: "50px", backgroundColor:"inherit", color:"inherit", border:"none", transition:"none" }}>
							{
								hasProfileImageSignal.value && (<img className="profile-image" src={profileImageSrcSignal.value} />)
							}
							<span className="username">{userManifestSignal.value.username}</span>
							<span style={{ position: "absolute", right: "0.6rem" }} className="icon-wrapper">
								<Icon icon="chevron-down" width={16} height={16}></Icon>
							</span>
						</Dropdown.Toggle>
						<Dropdown.Menu>
							{
								navigateTo4tressUrlSignal.value && (
									<Dropdown.Item href={navigateTo4tressUrlSignal.value}>
										<span className="me-1">
											<Icon icon="lock" height={16} width={16}></Icon>
										</span>
										Navigate to 4tress
									</Dropdown.Item>
								)
							}
							<Dropdown.Item href={emberUrlSignal.value}>
								<span className="me-1">
									<Icon icon="old" width={16} height={16}></Icon>
								</span>
								Switch to old experience
							</Dropdown.Item>
							<Dropdown.Item onClick={() => { showModalAboutSignal.value = true; }}>
								<label>
									<span className="me-1">
										<Icon icon="info-circle" height={16} width={16}></Icon>
									</span>
									About
								</label>
							</Dropdown.Item>
							<Dropdown.Item onClick={() => removeSelectedBusinessEntityId() } href={`${config.ssoBaseUrl}/logout?clientid=4&redirectToReferer=true`}>
								<span className="me-1">
									<Icon icon="sign-out" height={16} width={16}></Icon>
								</span>
								Sign Out
							</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				)
			}
			<AboutModal showSignal={showModalAboutSignal} handleCancel={handleCloseModalAbout} config={config}></AboutModal>
		</>
	)
}
export default UserBox